import PropTypes from "prop-types";
import { IStyleParam } from "../../../utils/propType";
export const ITextBasePropTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  tooltipParam: PropTypes.shape({
    isTooltip: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  }),
  styleParam: IStyleParam,
};



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/IpropType/basePropTypes.js